import React from "react";
import { useState, useEffect, useRef, useLayoutEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { TwitterShareButton, FacebookShareButton } from "react-share";

import { Helmet } from "react-helmet-async";
import { SearchContext } from "./Contexts/Context";
import { useContext } from "react";

import {
  FaEnvelope,
  FaPhoneAlt,
  FaFacebookF,
  FaTwitter,
  FaAngleLeft,
  FaInstagram,
  FaYoutube,
} from "react-icons/fa";
import {
  getMemberBySlug,
  getMembersByPosition,
  getPositions,
} from "../service/service";
import { use } from "react";

function SakrebulosTavmjdomare() {
  const navigate = useNavigate();
  const { language } = useContext(SearchContext);
  const [member, setMember] = useState({});
  const [loading, setLoading] = useState(true);
  const [tavmjdomare, setTavmjdomare] = useState([]);
  const [positionTavmjdomare, setPositionTavmjdomare] = useState({});
  const [sakrebuloTavmjdomare, setSakrebuloTavmjdomare] = useState({});
  const [sakrebyloLoading, setSakrebuloLoading] = useState(false);

  useEffect(() => {
    const link = `https://khulo.gov.ge/api/members.php?`;
    fetch(link)
      .then((response) => response.json())
      .then((data) => {
        Object.entries(data).map((item) => {
          if (item[1].geo.position.includes("თავჯდომარე")) {
            setMember(item);
          }
        });
      });

    setLoading(false);
  }, []);
  const [menu, setMenu] = useState({});
  useEffect(() => {
    const link = "https://khulo.gov.ge/api/site_menu1.php";
    fetch(link)
      .then((response) => response.json())
      .then((data) => {
        setMenu(data.menu);

        Object.entries(menu).map((item) => {
          if (item[1].level == 1) {
          }
        });
      });
  }, []);
  const presscenterList = Object.entries(menu).length
    ? Object.entries(menu).map((item, index) => {
        if (item[1].level == 1 && item[1].name_geo === "საკრებულო") {
          return Object.entries(menu).map((qveItem, index) => {
            if (qveItem[1].parent_id == item[1].cat_id) {
              const windoww = window.location.pathname;
              const result = windoww.split("/").pop();
              const slugg = qveItem[1].slug;
              return (
                <span key={index} className={result === slugg ? "active" : ""}>
                  <Link to={`/${qveItem[1].slug}`}>
                    {language == 1 ? qveItem[1].name_geo : qveItem[1].name_eng}
                  </Link>
                </span>
              );
            }
          });
        }
      })
    : "LOADING";

  const positions = async () => {
    await getPositions().then((data) => {
      setPositionTavmjdomare(data[0].position);
    });
  };

  const getTavjdomare = async (positionTavmjdomare) => {
    await getMembersByPosition(positionTavmjdomare).then((data) => {
      setTavmjdomare(data);
    });
  };

  const getTavmjdomareBySug = async (slug) => {
    await getMemberBySlug(slug).then((data) => {
      setSakrebuloTavmjdomare(data);
      setSakrebuloLoading(true);
    });
  };

  useEffect(() => {
    positions();
    getTavjdomare(positionTavmjdomare);
  }, [positionTavmjdomare]);

  useEffect(() => {
    if (tavmjdomare.length > 0) {
      getTavmjdomareBySug(tavmjdomare[0].slug);
    }
  }, [tavmjdomare]);

  // sakrebuloTavmjdomare
  const SakrebuloTavmjdomareFC = () => {
    return (
      <>
        {sakrebyloLoading ? (
          <div>
            <div className="sakrebulo-landing sakrebulo1">
              <div className="landing-container">
                <div className="image-wrapper">
                  <img src={sakrebuloTavmjdomare?.image} alt="" />
                  <div className="sakrebulo-landing-near-image">
                    <h3>{sakrebuloTavmjdomare?.full_name}</h3>
                    <span>
                      {" "}
                      {tavmjdomare[0]?.memberships[0]?.position_name}
                    </span>
                    <div className="">
                      <div className="socials"></div>
                    </div>
                    {/* <div className='languages'>
											<h3>ენები: {member[1].geo.language} </h3> <span></span>
										</div> */}
                  </div>
                </div>
                <div className="sakrebulo-landing-paragraphs">
                  <span
                    dangerouslySetInnerHTML={{
                      __html: sakrebuloTavmjdomare?.description,
                    }}
                  ></span>
                </div>
              </div>
              <div className="share">
                <span className="back" onClick={() => navigate(-1)}>
                  <div>
                    <FaAngleLeft />
                  </div>
                  {language == 1 ? "უკან დაბრუნება" : "BACK"}{" "}
                </span>
                <span>
                  {language == 1 ? "   გააზიარე:" : ""}
                  {language == 2 ? "SHARE:" : ""}
                  <FacebookShareButton url={window.location.href}>
                    <FaFacebookF />
                  </FacebookShareButton>
                  <TwitterShareButton url={window.location.href}>
                    <FaTwitter />
                  </TwitterShareButton>
                </span>
              </div>
            </div>
            <div className="presscenter-info">{presscenterList}</div>
          </div>
        ) : (
          <h1>LOADING</h1>
        )}
      </>
    );
  };

  if (loading) return <h1>LOADING</h1>;
  return (
    <motion.div
      intial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="news-container margin-280px">
        <header>
          <span className="big">
            {" "}
            {language == 1 ? "საკრებულო" : " "}
            {language == 2 ? "KHULO CITY ASSEMBLY" : " "}
          </span>

          <span>საკრებულოს თავჯდომარე</span>
        </header>
        <SakrebuloTavmjdomareFC />
      </div>
      {/* {memberie} */}
    </motion.div>
  );
}

export default SakrebulosTavmjdomare;
